import styled, { css } from 'styled-components'
import { Chips } from 'components'

type TEChips = {
  isDarkMode: boolean
  isActive: boolean
}

export const EChips = styled(Chips)<TEChips>`
  & > div {
    display: flex;
    height: 30px;
    align-items: center;

    div {
      display: flex;
    }

    ${({ isDarkMode }) =>
      isDarkMode &&
      css<TEChips>`
        span {
          color: ${({ isActive }) => (isActive ? '#161616' : '#ffffff')};
        }
      `}
  }
`
